import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorHandleService } from './error-handle.service';
import { catchError, Observable, of } from 'rxjs';
import { GolfMembership } from '../interface/golf-membership';
//TW20250924
import { GolfRoundResponse, GolfMemberResponse, GolfResponse, GolfRevenueResponse, GolfRevenueTotal, GolfRevenueTotalResponse } from '../models/golf-membership';
import { environment } from '../../../environments/environment.development';


@Injectable({
  providedIn: 'root'
})
export class GolfMemberService {
  private apiUrl = `${environment.APIDEV}`;


  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }

  GetListMemberGolf(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: 'ASC' | 'DESC',
    startDate?: string,
    endDate?: string,
    memberTypeId: number | null = null
  ): Observable<GolfResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());

    if (search) {
      params = params.set('search', search);
    }
    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }
    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    if (memberTypeId !== null) params = params.set('filter', memberTypeId);

    return this.http.get<GolfResponse>(`${this.apiUrl}golf/member_list`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  golfRevenue(
    startDate?: string,
    endDate?: string
  ): Observable<GolfRevenueResponse> {
    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<GolfRevenueResponse>(`${this.apiUrl}golf/revenue`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  golfRevenueTotal(
    startDate?: string,
    endDate?: string
  ): Observable<GolfRevenueTotalResponse> {
    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<GolfRevenueTotalResponse>(`${this.apiUrl}golf/revenue_total`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  golfMemberType(
  ): Observable<GolfRevenueTotalResponse> {

    return this.http.get<GolfRevenueTotalResponse>(`${this.apiUrl}golf/member_type`, {
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  golfMembership(
    startDate?: string,
    endDate?: string
  ): Observable<GolfMemberResponse> {
    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<GolfMemberResponse>(`${this.apiUrl}golf/membership`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  //TW20250924: Added for round
  golfRound(
    startDate?: string,
    endDate?: string
  ): Observable<GolfRoundResponse> {
    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<GolfRoundResponse>(`${this.apiUrl}golf/golfround`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }
  
}
